import { Button, Modal } from "react-bootstrap";
import "./CompleteMsg.style.scss";
import { getProductInfo } from "src/utils/storage/product";
import { useTranslation } from "react-i18next";

interface ICompleteMsgModalProps {
  showMsgModal: boolean;
  closeButtonMsg: () => void;
}
const CompleteMsgModal = ({
  showMsgModal,
  closeButtonMsg,
}: ICompleteMsgModalProps) => {
  const product = getProductInfo().key;
  const { t } = useTranslation();
  return (
    <Modal
      show={showMsgModal}
      onHide={closeButtonMsg}
      className="complete-modal"
      style={{ opacity: 1 }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t("siteManagement.createSite.siteCreatedTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="ok-sign"></div>
        <p className="msg-body">
          {t("siteManagement.createSite.siteCreatedBody")}
        </p>
        <p className="msg-desc">
          {t(`siteManagement.createSite.siteCreatedDesc.${product}`)}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn btn-green height h-36 width w-100"
          onClick={closeButtonMsg}
        >
          {t("common.okBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CompleteMsgModal;
